export * from './resources'
export * from './zod-config'
export * from './register'

export const UI_I18N_NAMESPACE_MAP = {
  COMMON: 'ui-common',
  COMPONENTS: 'ui-components',
  INIT: 'ui-init',
  BEFEHLE: 'ui-befehle',
  VALIDATION: 'ui-validation'
} as const

export const UI_I18N_NAMESPACES = Object.values(UI_I18N_NAMESPACE_MAP)
